import OnboardingGuide from "@/components/OnboardingGuide";

export default function GettingStarted() {
  return (
    <div className="p-6 lg:p-8 max-w-4xl mx-auto space-y-6" data-testid="getting-started-page">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">Empieza aquí</h1>
        <p className="text-slate-600 dark:text-slate-400 mt-1">
          Sigue estos pasos para dejar tu tienda lista en pocos minutos.
        </p>
      </div>
      <OnboardingGuide />
    </div>
  );
}
